import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

function UserDropdown({ props }) {
  console.log(props);
  const { t } = useTranslation();
  const progressBarRef = useRef(null);
  const moduleStatus = useSelector(
    (state) => state.dashboard?.appLayout?.moduleStatus
  );

  useEffect(() => {
    const strokeDashOffsetValue =
      100 - (props?.productValidity?.packageValidityPercentage ?? 100);
    progressBarRef.current.style.strokeDashoffset = strokeDashOffsetValue;
  }, [props?.productValidity?.packageValidityPercentage]);

  const popover = (
    <Popover id="popover-basic">
      {props?.activePvStatus ? (
        <>
          <Popover.Header as="h3" >Monthly goal  met</Popover.Header>
          <Popover.Body >
           You have met the monthly goal of {props?.minActiveCC}.
          </Popover.Body>
        </>
      ) : (
        <>
          <Popover.Header as="h3">Monthly goal not met</Popover.Header>       
          <Popover.Body>
            To meet this monthly goal, you should have {props?.minActiveCC} {t('activePv')}
          </Popover.Body>
        </>
      )}
    </Popover>
  );

  return (
    <>
      <aside className="left_sidebar"></aside>
      <div className="rightSide_top_user_dropdown">
        <div className="rightSide_top_user_dropdown_avatar_sec">
          <div className="rightSide_top_user_dropdown_avatar">
            <img
              src={props?.image ? props?.image : "/images/user-profile.png"}
              alt=""
            />
            {moduleStatus?.kyc_status === 1 ? (
              <div className="kyc_vrfd">
                {props?.kycStatus ? (
                  <img src="/images/kyc_vrfd.svg" alt="" />
                ) : (
                  <img src="/images/kyc_not_vrfd.png" alt="" />
                )}
              </div>
            ) : (
              <div className="kyc_vrfd">
                <img src="/images/kyc_vrfd.svg" alt="" />
              </div>
            )}
            <svg
              className="profile_progress"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="-1 -1 34 34"
            >
              <circle
                cx="16"
                cy="16"
                r="15.9155"
                className="progress-bar__background"
              />
              <circle
                cx="16"
                cy="16"
                r="15.9155"
                className="progress-bar__progress js-progress-bar"
                ref={progressBarRef}
              />
            </svg>
          </div>
        </div>
        <div className="rightSide_top_user_dropdown_nameBOx">
          <div className="rightSide_top_user_dropdown_name">
            {props?.fullname}
          </div>
          <div className="rightSide_top_user_dropdown_id">
            {props?.username}
          </div>

        
            <div
              className="rightSide_top_user_dropdown_package"
              style={{
                background: props?.activePvStatus ? "green" : "red",
                color: "white",
                cursor: "pointer",
              }}
            >
               
              {props?.activePvStatus ? t("active") : t("inactive")}
            </div>
              <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="top"
            overlay={popover}
          >
             <i
              className="fa fa-info-circle"
              style={{fontSize: "13px", marginLeft: "3px",marginTop:"2px" }}
            ></i>
          </OverlayTrigger>
        </div>
      </div>
      <div className="top_right_personal_dtl_box_sec">
        <div className="top_right_personal_dtl_box border-sprt">
          <span>{t("personalPV")}</span>
          {parseFloat(props?.personalPv) >= parseFloat(props?.minPersonalCC) ? (
            <i
              className="fa-solid fa-circle-check"
              style={{ color: "green", fontSize: "12px", marginLeft: "3px" }}
            ></i>
          ) : (
            <i
              className="fa fa-times-circle"
              style={{ color: "red", fontSize: "12px", marginLeft: "3px" }}
            ></i>
          )}
          <strong>{props?.personalPv ?? 0}</strong>
        </div>
        <div className="top_right_personal_dtl_box">
          <span>{t("guestPv")}</span>
          <strong>{props?.guestPv ?? 0}</strong>
        </div>
      </div>
      <div className="top_right_personal_dtl_box_sec">
        <div className="top_right_personal_dtl_box border-sprt">
          <span>{t("activePv")}</span>
         
          {parseFloat(props?.activePv) >= parseFloat(props?.minActiveCC) ? (
            <i
              className="fa-solid fa-circle-check"
              style={{ color: "green", fontSize: "12px", marginLeft: "3px" }}
            ></i>
          ) : (
            <i
              className="fa fa-times-circle"
              style={{ color: "red", fontSize: "12px", marginLeft: "3px" }}
            ></i>
          )}
          <strong>{props?.activePv ?? 0}</strong>
        </div>
        <div className="top_right_personal_dtl_box">
          <span>{t("totalPv")}</span>
          <strong>{props?.totalPv ?? 0}</strong>
        </div>
      </div>
      <div className="top_right_personal_dtl_box_sec">
        <div className="top_right_personal_dtl_box text-center">
          <span>{t("sponsor")}</span>
          <strong>{props?.sponsorName}</strong>
        </div>
      </div>
      {/* {props?.leaderRankActive ?
      <div className="top_right_personal_dtl_box_sec">
        <div className="top_right_personal_dtl_box text-center">
          <strong style={{color:"green",fontSize:"15px"}}>{t("LBQqulified")}</strong>
        </div>
      </div>:(<></>)} */}


      
      <div className="top_profile_upgrade_renew_btn_sec">
        {(moduleStatus?.product_status || moduleStatus?.ecom_status) && (
          <>
            {moduleStatus?.package_upgrade === 1 && (
              <>
                {props?.upgradeLink ? (
                  <>
                    <a
                      className="top_profile_upgrade_renew_btn_1"
                      href={props.upgradeLink}
                    >
                      {t("upgrade")}
                    </a>
                  </>
                ) : (
                  <>
                    <NavLink
                      onClick={() => {
                        if (
                          !props?.subscriptionDetails?.showRenew &&
                          props?.subscriptionDetails?.autoRenewalStatus === 1
                        ) {
                          toast.error(t("warning cancel auto-renewal first."));
                        }
                      }}
                      to={{
                        pathname:
                          props?.subscriptionDetails?.autoRenewalStatus === 0
                            ? "/upgrade"
                            : "/dashboard",
                        search: `?previousPage=${encodeURIComponent(
                          "/dashboard"
                        )}`,
                      }}
                      className="top_profile_upgrade_renew_btn_1"
                    >
                      {t("upgrade")}
                    </NavLink>
                  </>
                )}
              </>
            )}
            {moduleStatus?.subscription_status === 1 &&
              props?.subscriptionDetails?.showRenew && (
                <>
                  {props.renewLink ? (
                    <>
                      <a
                        className="top_profile_upgrade_renew_btn_1"
                        href={props.renewLink}
                      >
                        {t("renew")}
                      </a>
                    </>
                  ) : (
                    <>
                      <NavLink
                        to={{
                          pathname: "/renew",
                          search: `?previousPage=${encodeURIComponent(
                            "/dashboard"
                          )}`,
                        }}
                        className="top_profile_upgrade_renew_btn_1"
                      >
                        {t("renew")}
                      </NavLink>
                    </>
                  )}
                </>
              )}
            {props?.subscriptionDetails?.autoRenewalStatus === 1 && (
              <NavLink
                to={{ pathname: "/profile" }}
                className="top_profile_upgrade_renew_btn_1"
              >
                {t("Renew")}
              </NavLink>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default UserDropdown;
